export const diasSemana = {
  0: 'Domingo',
  1: 'Lunes',
  2: 'Martes',
  3: 'Miercoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sabado'
}

export function obtenerDiaDeLaSemana (fechaStr) {
  const partes = fechaStr.split('/')

  if (partes.length !== 3) {
    // console.error(`Error: El formato de fecha '${fechaStr}' no es válido. Se espera 'DD/MM/AAAA'.`)
    return null
  }

  const dia = parseInt(partes[0], 10)
  const mes = parseInt(partes[1], 10)
  const anio = parseInt(partes[2], 10)

  const mesIndex = mes - 1
  const fecha = new Date(anio, mesIndex, dia)

  if (isNaN(fecha.getTime())) {
    // console.error('Error: La fecha es NaN. Valores parseados:', { anio, mesIndex, dia })
    return null
  }

  const diaDeLaSemanaIndex = fecha.getDay()
  const nombreDia = diasSemana[diaDeLaSemanaIndex]
  return nombreDia
}
